import {GameUtils} from '@fantasmagames/slot/src/utils/GameUtils';

export class SliderNumberBox extends PIXI.Sprite {
	protected _text: PIXI.Text;
	protected _buttonSprite: PIXI.Sprite;
	protected _isMobile: boolean;
	protected _event: string;
	protected _scaleMod: number;

	constructor(buttonSprite: PIXI.Sprite, style: PIXI.TextStyle, isMobile: boolean, scaleMod: number) {
		super();

		this.initialize(buttonSprite, style, isMobile, scaleMod);
	}

	public updateNumber(newNumber: string): void {
		if (!this._text) {
			return;
		}
		this._text.text = newNumber;
		this.scaleNumber(this._text);
	}

	protected initialize(buttonSprite: PIXI.Sprite, style: PIXI.TextStyle, isMobile: boolean, scaleMod: number): void {
		this._isMobile = isMobile;
		this._scaleMod = scaleMod;
		this._buttonSprite = buttonSprite;

		this.createButton(buttonSprite);
		this.createNumber(buttonSprite, style);
	}

	protected createButton(buttonSprite: PIXI.Sprite): PIXI.Sprite {
		this.addChild(buttonSprite);
		buttonSprite.anchor.set(0.5, 0.5);

		return buttonSprite;
	}

	protected createNumber(parentSprite: PIXI.Sprite, style: PIXI.TextStyle): PIXI.Text {
		this._text = new PIXI.Text('0', style);
		parentSprite.addChild(this._text);
		this._text.anchor.set(0.5, 0.5);

		return this._text;
	}

	protected scaleNumber(text: PIXI.Text): void {
		text.scale.set(1, 1);

		const maxSize = {
			x: this._buttonSprite.width * this._scaleMod,
			y: this._buttonSprite.height * this._scaleMod,
		};

		if (text.width > maxSize.x || text.height > maxSize.y) {
			GameUtils.correctSpriteScale(text, maxSize);
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/display/Slider/SliderNumberBox.ts